const CabecalhoSection = () => (
  <>
    <header>
    <div className='tituloEscola'><h2 style={{ fontSize: 40 + 'px'}}>Ensino Fundamental II</h2></div>
      <p>Sistema de Ensino</p>
        <div className='sistemaContainer'>
          <a href='https://www.plurall.net/' rel='noreferrer' target='_blank'>
            <div className='itensSistema'>
              <img src='assets/images/sistemas/plurall.png' alt='Plurall'/>
              PLURALL
            </div>
          </a>
        </div>
    </header>

    <section className="ensino">
      <p>
        O Ensino Fundamental II, abrangendo do 6º ao 9º ano, é projetado com um olhar atento
        às particularidades da adolescência. Esse período educativo continua a fomentar a
        autonomia intelectual e moral dos jovens, incentivando o uso de diversas formas de
        linguagem para expressar suas ideias. Enfatiza o desenvolvimento do pensamento lógico,
        da criatividade e da análise crítica. Reconhecendo que essa fase é marcada por profundas
        transformações físicas, psicológicas e emocionais, nossa abordagem é cuidadosamente adaptada
        às necessidades específicas de cada faixa etária. Isso inclui desde a atenção especial às
        demandas de adaptação dos alunos do 6º ano até o suporte necessário para que os alunos do 9º ano
        façam a transição para o Ensino Médio. Além disso, incentivamos a participação ativa em projetos interdisciplinares
        e atividades extracurriculares, promovendo um aprendizado mais dinâmico e integral.
      </p>
    </section>
  </>
);

export default CabecalhoSection;
